export default __webpack_public_path__ + "static/media/Steering_Behaviour.06877b3c.jpeg";